export var BuyingGroupContactsAccounts;
(function (BuyingGroupContactsAccounts) {
    BuyingGroupContactsAccounts["NONE"] = "NONE";
    BuyingGroupContactsAccounts["WITH_LEADS"] = "WITH_LEADS";
    BuyingGroupContactsAccounts["ACTIVE"] = "ACTIVE";
})(BuyingGroupContactsAccounts || (BuyingGroupContactsAccounts = {}));
export var CampaignState;
(function (CampaignState) {
    CampaignState["Unspecified"] = "unspecified";
    CampaignState["Creating"] = "creating";
    CampaignState["Created"] = "created";
    CampaignState["AwaitingProcessing"] = "awaiting_processing";
    CampaignState["UploadedDomainsFileCreationProcessing"] = "uploaded_domains_file_creation_processing";
    CampaignState["UploadedDomainsFileCreationProcessed"] = "uploaded_domains_file_creation_processed";
    CampaignState["UploadedDomainsFileCreationError"] = "uploaded_domains_file_creation_error";
    CampaignState["BlocklistedDomainsFileCreationProcessing"] = "blocklisted_domains_file_creation_processing";
    CampaignState["BlocklistedDomainsFileCreationProcessed"] = "blocklisted_domains_file_creation_processed";
    CampaignState["BlocklistedDomainsFileCreationError"] = "blocklisted_domains_file_creation_error";
    CampaignState["FirmographicsDomainsFileCreationProcessing"] = "firmographics_domains_file_creation_processing";
    CampaignState["FirmographicsDomainsFileCreationProcessed"] = "firmographics_domains_file_creation_processed";
    CampaignState["FirmographicsDomainsFileCreationError"] = "firmographics_domains_file_creation_error";
    CampaignState["DomainsListCreationProcessing"] = "domains_list_creation_processing";
    CampaignState["DomainsListCreationProcessed"] = "domains_list_creation_processed";
    CampaignState["DomainsListCreationError"] = "domains_list_creation_error";
    CampaignState["TalFileCreationProcessing"] = "tal_file_creation_processing";
    CampaignState["TalFileCreationProcessed"] = "tal_file_creation_processed";
    CampaignState["TalFileCreationError"] = "tal_file_creation_error";
    CampaignState["TalDomainsValidationProcessing"] = "tal_domains_validation_processing";
    CampaignState["TalDomainsValidationProcessed"] = "tal_domains_validation_processed";
    CampaignState["TalDomainsValidationError"] = "tal_domains_validation_error";
    CampaignState["TalFileLoadProcessing"] = "tal_file_load_processing";
    CampaignState["TalFileLoadProcessed"] = "tal_file_load_processed";
    CampaignState["TalFileLoadError"] = "tal_file_load_error";
    CampaignState["TalFileDomainEnhancementProcessing"] = "tal_file_domain_enhancement_processing";
    CampaignState["TalFileDomainEnhancementProcessed"] = "tal_file_domain_enhancement_processed";
    CampaignState["TalFileDomainEnhancementError"] = "tal_file_domain_enhancement_error";
})(CampaignState || (CampaignState = {}));
export var CampaignDeliveryRecipientType;
(function (CampaignDeliveryRecipientType) {
    CampaignDeliveryRecipientType["Unspecified"] = "unspecified";
    CampaignDeliveryRecipientType["Intent"] = "intent";
    CampaignDeliveryRecipientType["BuyingGroup"] = "buying_group";
    CampaignDeliveryRecipientType["LeadActivationSummaries"] = "lead_activation_summaries";
})(CampaignDeliveryRecipientType || (CampaignDeliveryRecipientType = {}));
export var Dynamic1Status;
(function (Dynamic1Status) {
    Dynamic1Status[Dynamic1Status["Unspecified"] = 0] = "Unspecified";
    Dynamic1Status[Dynamic1Status["ProcessStarted"] = 1] = "ProcessStarted";
    Dynamic1Status[Dynamic1Status["Processing"] = 2] = "Processing";
    Dynamic1Status[Dynamic1Status["Completed"] = 3] = "Completed";
    Dynamic1Status[Dynamic1Status["Disabled"] = 4] = "Disabled";
})(Dynamic1Status || (Dynamic1Status = {}));
export var CampaignDomainSource;
(function (CampaignDomainSource) {
    CampaignDomainSource["Uploaded"] = "uploaded";
    CampaignDomainSource["Firmographic"] = "firmographic";
    CampaignDomainSource["Expanded"] = "expanded";
    CampaignDomainSource["Replaced"] = "replaced";
})(CampaignDomainSource || (CampaignDomainSource = {}));
export var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus[CampaignStatus["Active"] = 1] = "Active";
    CampaignStatus[CampaignStatus["Ended"] = 2] = "Ended";
})(CampaignStatus || (CampaignStatus = {}));
export var SignalSelectionSource;
(function (SignalSelectionSource) {
    SignalSelectionSource["Unspecified"] = "unspecified";
    SignalSelectionSource["Autodiscovery"] = "autodiscovery";
    SignalSelectionSource["Csv"] = "csv";
    SignalSelectionSource["Manual"] = "manual";
    SignalSelectionSource["Suggestion"] = "suggestion";
})(SignalSelectionSource || (SignalSelectionSource = {}));
export var CampaignDomainStatus;
(function (CampaignDomainStatus) {
    CampaignDomainStatus["Unspecified"] = "unspecified";
    CampaignDomainStatus["Good"] = "Good";
    CampaignDomainStatus["Bad"] = "Bad";
    CampaignDomainStatus["NoIpResolution"] = "No IP Resolution";
})(CampaignDomainStatus || (CampaignDomainStatus = {}));
export var CampaignClientTargetAccountSource;
(function (CampaignClientTargetAccountSource) {
    CampaignClientTargetAccountSource["Unspecified"] = "unspecified";
    CampaignClientTargetAccountSource["Client"] = "client";
    CampaignClientTargetAccountSource["Firmographics"] = "firmographics";
})(CampaignClientTargetAccountSource || (CampaignClientTargetAccountSource = {}));
export var CampaignAutodiscoveryStatus;
(function (CampaignAutodiscoveryStatus) {
    CampaignAutodiscoveryStatus["STATE_UNSPECIFIED"] = "state_unspecified";
    CampaignAutodiscoveryStatus["PROCESSING"] = "processing";
    CampaignAutodiscoveryStatus["PROCESSED"] = "processed";
    CampaignAutodiscoveryStatus["ERROR"] = "error";
})(CampaignAutodiscoveryStatus || (CampaignAutodiscoveryStatus = {}));
export var CampaignDomainEnhancementStatus;
(function (CampaignDomainEnhancementStatus) {
    CampaignDomainEnhancementStatus["STATE_UNSPECIFIED"] = "state_unspecified";
    CampaignDomainEnhancementStatus["PROCESSING"] = "processing";
    CampaignDomainEnhancementStatus["PROCESSED"] = "processed";
    CampaignDomainEnhancementStatus["ERROR"] = "error";
})(CampaignDomainEnhancementStatus || (CampaignDomainEnhancementStatus = {}));
//# sourceMappingURL=Campaign.js.map